import React, { useState } from "react";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import arenaImg from "./images/arena.jpeg";
// Import your API utility (adjust the path as needed)
import api from "./helpers/Api";
import {useAuth} from './hooks/useAuth';
import {AuthProvider} from "./context/AuthContext";

function CreateAccount() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const auth = useAuth();
 

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!firstName || !lastName || !email || !password || !confirm) {
      setError("All fields are required.");
      return;
    }
    // Simple email format check
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    //setSubmitting(true);
			
			auth.register({firstName, lastName, email, password})
				?.then(() => {
          setSuccess("Account created! Please check your email.");
          setTimeout(() => navigate("/"), 1500);
					
				})
				.catch((error) => {
					//setSubmitting(false);
					setError(error.message);
				});

    /*const result = await api.createAccount({ firstName, lastName, email, password });

    if (result && result.success) {
      setSuccess("Account created! Please check your email.");
      setTimeout(() => navigate("/"), 1500);
    } else {
      setError(result && result.message ? result.message : "Account creation failed. Please try again.");
    }*/
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `url(${arenaImg}) center/cover no-repeat #f8f6f2`,
        width: "100vw",
        boxSizing: "border-box",
        overflowX: "hidden"
      }}
    >
      <form
        style={{
          background: "#fff",
          padding: "48px 32px",
          borderRadius: "16px",
          boxShadow: "0 8px 32px rgba(40,44,52,0.15)",
          minWidth: "320px",
          maxWidth: "380px",
          width: "90vw",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxSizing: "border-box"
        }}
        onSubmit={handleSubmit}
      >
        <Header onBack={() => navigate(-1)} style={{ marginBottom: "20px" }} />
        <h2 style={{ marginBottom: 18, marginTop: "2px" }}>Create Account</h2>
        <input
          type="text"
          placeholder="First Name"
          value={firstName}
          onChange={e => setFirstName(e.target.value)}
          style={{
            marginBottom: 16,
            padding: "10px",
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "1rem"
          }}
          required
        />
        <input
          type="text"
          placeholder="Last Name"
          value={lastName}
          onChange={e => setLastName(e.target.value)}
          style={{
            marginBottom: 16,
            padding: "10px",
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "1rem"
          }}
          required
        />
        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={e => setEmail(e.target.value)}
          style={{
            marginBottom: 16,
            padding: "10px",
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "1rem"
          }}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          style={{
            marginBottom: 16,
            padding: "10px",
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "1rem"
          }}
          required
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirm}
          onChange={e => setConfirm(e.target.value)}
          style={{
            marginBottom: 16,
            padding: "10px",
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "1rem"
          }}
          required
        />
        {error && <div style={{ color: "red", marginBottom: 12 }}>{error}</div>}
        {success && <div style={{ color: "green", marginBottom: 12 }}>{success}</div>}
        <button
          type="submit"
          style={{
            background: "#1976d2",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "10px 22px",
            fontWeight: 700,
            fontSize: "1rem",
            cursor: "pointer"
          }}
        >
          Create Account
        </button>
      </form>
    </div>
  );
}

export default CreateAccount;